import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmw } from '../entity/Stkmw-angular';


@Injectable({
  providedIn: 'root'
})
export class StkmwServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Stkmw();
    this.entityType.type = EntityType.data;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MW001: '交易所代號', MW002: '交易所名稱', MW003: '備註'
    };

    this.fieldNames = 'MW001,MW002,MW003';
    this.fieldLengths = { MW001: 8, MW002: 40, MW003: 255 };
    this.columnDefs = [
      { field: "MW001", headerName: "交易所代號", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MW002", headerName: "交易所名稱", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MW003", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'STKMW';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMW.*  FROM STKMW`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MW001`;
    this.keyFields = ['MW001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MW001'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Stkmw): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmw): Promise<Stkmw> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
